<app-showcase></app-showcase>
<app-bulletin></app-bulletin>
<app-parent></app-parent>
<app-why></app-why>
<app-life></app-life>
<app-check-out></app-check-out>
<app-activities></app-activities>